export default __webpack_public_path__ + "static/media/47-safe-mama.5ef80859.jpg";